// Imports
import { darken, lighten } from 'polished';
import styled, { css } from 'styled-components/macro';
import { GeneratedThemeProps } from '../../../../../../templates/template-style';


// Styled component
const BottomInfo = styled.div<{ theme: GeneratedThemeProps }>`
	max-width: 62.5rem;
	margin-left: auto;
	margin-right: auto;
	
	padding: 0 1.25rem 1.25rem;
	
	${({ theme }) => {
		if (theme.isModernOrNatureStyle) {
			return css`
				background: ${lighten(theme.customBottomInfoBackgroundLighten ?? 0.35, theme.baseColor)};
			`;
		}
		
		if (theme.isPaper) {
			return css`
				background: #fff;
			`;
		}
		
		return css`
			background: ${lighten(0.45, theme.baseColor)};
		`;
	}}
	
	box-shadow: ${({ theme }) => `0 0 .3125rem rgba(0, 0, 0, ${theme.isPaper ? '0.15' : '0.2'})`};
	
	${({ theme }) =>
		theme.isFreshStyle &&
		css`
			border-radius: 0.3125rem;
		`}
	
	h3 {
		font-size: 1.5rem;
		font-weight: 500;
		line-height: 1.65rem;
		
		margin: 0;
		padding-bottom: 0.625rem;
		color: ${({ theme }) => darken(0.2, theme.baseColor)};
		
		text-align: center;
		
		padding-top: 1.25rem;
	}
	
	a {
		color: ${({ theme }) => (theme.bottomInfoLinkIsBaseColor ? theme.baseColor : lighten(0.1, theme.baseColor))};
		text-decoration: ${(props) => (props.theme.isPaper ? 'underline' : 'none')};
		
		&:hover,
		&:focus {
			color: ${(props) => darken(0.05, props.theme.baseColor)};
			
			${(props) =>
				props.theme.isPaper &&
				css`
					text-decoration: none;
				`};
		}
	}
	
	color: #333;
	font-size: 0.8125rem;
	line-height: 1.0625rem;
	
	&:not(:last-child) {
		margin-bottom: 1.25rem;
	}
`;

export default BottomInfo;
